// Get location interests list for a user  ****************
// pathname: /v1/user/location-interests
// **********************************************************
import { useSwrApi } from '@hooks/useSwrApi';
import type { InterestData } from './types';

interface UseSwrLocationInterestsProps {
  locale?: Locale;
  shouldFetch?: boolean;
  serverData?: InterestData[];
}

/**
 * @description SWR Get location interests list for a user.
 * @param props
 */
export const useSwrLocationInterests = (props: UseSwrLocationInterestsProps) => {
  const { locale = 'ro', shouldFetch = true, serverData } = props;

  const {
    data, error, isLoading, isValidating, mutate,
  } = useSwrApi<InterestData[]>({
    url: '/v1/user/location-interests',
    locale,
    shouldFetch,
    serverSideData: serverData,
    apiOptions: {
      dedupingInterval: 60 * 1000, // 1 minute
    },
  });

  return {
    data,
    error,
    mutate,
    isLoading,
    isValidating,
  };
};
